import { Box, Typography, Container } from "@mui/material";
import React from "react";
import Header from "../components/common/Header";
import MandateSuccessAnimation from "../components/Lottie/MandateSuccessAnimation";
import ErrorAnimation from "../components/Lottie/ErrorAnimation";
import { useLocation } from "react-router-dom";
import { Link } from "@mui/material";
import { useNavigate } from "react-router";
import styles from "../Style/Modules/paymentSuccess.module.css";
import "../Style/Theme/index.css";

export default function PaymentSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  window.history.forward();
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={16} />
        <Box>
          {location?.state?.paymentstatus === "Paid" ? (
            <Box className={styles.paymentSuccessBox}>
              <Typography variant="h2" className={styles.paymentSuccessTyp}>
                Payment Successful
              </Typography>
              <MandateSuccessAnimation />
              <label className="subTitle_Th">
                <b>Reference ID:</b>
                {location?.state?.referenceno}
              </label>
              <label className="subTitle_Th">
                <b>Amount:</b>
                {location?.state?.amount}
              </label>
              <label className="subTitle_Th">
                <b>Paid Amount:</b>
                {location?.state?.paidamount}
              </label>
              <label className="subTitle_Th">
                <b>Payment Status:</b>
                {location?.state?.paymentstatus}
              </label>{" "}
              <Typography
                variant="h7"
                sx={{ color: "#0D1C6E", mt: "40px", cursor: "pointer" }}
              >
                To do more repayment {/* <Link onClick={() => navigate(-1)}> */}
                <Link
                  onClick={() =>
                    location?.state?.mn
                      ? navigate("/repaymentLMS", {
                          state: { mn: location?.state?.mn },
                        })
                      : navigate(-1)
                  }
                >
                  <b>CLICK HERE</b>
                </Link>
              </Typography>
            </Box>
          ) : (
            <Box className={styles.paymentSuccessBox}>
              {" "}
              <Typography
                variant="h2"
                className="errorMsg_Th"
                sx={{ textAlign: "center" }}
              >
                Payment Unsuccessful
                <br />
                <br />
              </Typography>
              <ErrorAnimation />
              <label className="subTitle_Th">
                {" "}
                Please check your sms or email for payment link or contact our
                support team.
              </label>
              <br />
              <label className="subTitle_Th">
                <b>Reference ID: </b>
                {location?.state?.referenceno}
              </label>
              <label className="subTitle_Th">
                <b>Amount:</b>
                {location?.state?.amount}
              </label>
              <label className="subTitle_Th">
                <b>Paid Amount: </b>
                {location?.state?.paidamount}
              </label>
              <label className="subTitle_Th">
                <b>Payment Status: </b>
                {location?.state?.paymentstatus}
              </label>
            </Box>
          )}
        </Box>
      </Container>
    </>
  );
}
